import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useAuth } from 'react-oidc-context';

interface DecodedToken {
  // biome-ignore lint/style/useNamingConvention: <explanation>
  realm_access?: {
    roles: string[];
  };
}

export const Home: React.FC = () => {
  const auth = useAuth();
  const [userRoles, setUserRoles] = useState<string[]>([]);

  // Extract user roles from the token
  useEffect(() => {
    if (auth.isAuthenticated && auth.user?.access_token) {
      try {
        const decodedToken = jwtDecode(auth.user.access_token) as DecodedToken;
        const roles = decodedToken.realm_access?.roles || [];
        setUserRoles(roles);
      } catch (error) {
        console.error('Error decoding token:', error);
        setUserRoles([]);
      }
    }
  }, [auth.isAuthenticated, auth.user]);

  const hasCreationAccess = userRoles.some((role) =>
    ['kapnetix-admin', 'kapnetix-kapture'].includes(role.toLowerCase())
  );
  const hasCleaningAccess = userRoles.some((role) =>
    ['kapnetix-admin', 'kapnetix-cleaning'].includes(role.toLowerCase())
  );

  return (
    <>
      <h1 className={'text-2xl font-bold mb-8'}>Dashboard</h1>
      <div className={'flex flex-wrap items-stretch gap-8'}>
        {hasCreationAccess && (
          <Link to={'/capture'} className={'rounded-sm flex bg-gray-100 transition-all hover:bg-gray-200'}>
            <div className={'flex flex-col items-center w-full max-w-full min-w-72 p-6'}>
              <h2 className={'text-2xl font-bold mb-3'}>CAPTURE</h2>
              <p>Estimation of 3D pose from 2D using neural networks</p>
            </div>
          </Link>
        )}
        {hasCleaningAccess && (
          <Link to={'/cleaning'} className={'rounded-sm flex items-center bg-gray-100 transition-all hover:bg-gray-200'}>
            <div className={'flex flex-col items-center w-full max-w-full min-w-72 p-6'}>
              <h2 className={'text-2xl font-bold'}>CLEANING</h2>
            </div>
          </Link>
        )}
      </div>
    </>
  );
};
